/**
 * A budget item's `color` is a palette name shared with the iOS app ("green",
 * "kai", "orange"). The app maps those to SwiftUI colors; here they map to CSS.
 *
 * Unknown names fall back to the neutral rather than throwing, because the
 * scraper and older rows can hold anything and a wrong swatch is a far smaller
 * problem than a blank screen.
 */

import { normalizeItemColor } from '@alohamula/domain';

const SWATCHES: Record<string, string> = {
  green: 'var(--valley)',
  blue: 'var(--moana)',
  purple: 'var(--swatch-purple)',
  orange: 'var(--swatch-orange)',
  pink: 'var(--swatch-pink)',
  yellow: 'var(--kukui)',
  brown: 'var(--swatch-brown)',
  gray: 'var(--color-text-tertiary)',
  red: 'var(--alaea)',
  cyan: 'var(--kai)',
  indigo: 'var(--swatch-indigo)',
};

export function colorVar(color: string): string {
  return SWATCHES[normalizeItemColor(color)] ?? SWATCHES.gray;
}
